var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.linkProperties.is,_vm._b({tag:"component"},'component',_vm.linkProperties,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }